import axios from "axios";

/**
 * Resource visibility of the four sign resources.
 *
 * resource_type follows the module constants used by the backend :
 * 1 = document, 2 = template, 3 = send for sign, 4 = sign myself.
 */
export const RESOURCE_TYPE = {
    DOCUMENT: 1,
    TEMPLATE: 2,
    SEND_FOR_SIGN: 3,
    SIGN_MYSELF: 4,
};

export const VISIBILITY = {
    PUBLIC: 0,
    PRIVATE_ONLY_ME: 1,
    PRIVATE_SELECTED_USERS: 2,
};

export const getVisibility = (data, resp, error) => {
    axios.get(process.env.REACT_APP_VISIBILITY, { withCredentials: process.env.REACT_APP_CREDENTIALS, params: data })
        .then((res) => {
            resp(res);
        })
        .catch((err) => {
            error(err);
        });
};

export const updateVisibility = (data, resp, error) => {
    axios.put(process.env.REACT_APP_VISIBILITY, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
        .then((res) => {
            resp(res);
        })
        .catch((err) => {
            error(err);
        });
};
